import React from 'react';
import { Link, useParams } from 'react-router-dom';
import MarketingShell from '../../components/MarketingShell';
import HtmlBody from '../../components/HtmlBody';
import caseStudies from '../../data/marketing/caseStudies.json';

export default function CaseStudyDetailPage() {
  const { slug } = useParams();
  const study = caseStudies.find((item) => item.slug === slug && !item.isDraft);

  if (!study) {
    return (
      <MarketingShell title="Story not found">
        <Link to="/case-studies" className="text-sm font-medium text-gray-900">
          Back to stories
        </Link>
      </MarketingShell>
    );
  }

  return (
    <MarketingShell>
      <article className="rounded-xl border border-gray-100 bg-white p-6">
        <p className="text-xs font-medium uppercase tracking-wide text-gray-500">Case study</p>
        <h1 className="mt-2 text-xl font-semibold tracking-tight text-gray-900">{study.name}</h1>
        {study.quote ? (
          <blockquote className="mt-4 text-sm font-medium text-gray-900">{study.quote}</blockquote>
        ) : null}
        <div className="mt-6">
          <HtmlBody html={study.body} />
        </div>
      </article>
    </MarketingShell>
  );
}
